<div class="bg-image"></div>
<div class="row col-12 justify-content-center">
    <div class="row col-12 login-block">
        <div class="col-12 col-lg-6">
            <div class="col-12 text-center">
                <img src="assets/img/UnityC_RGB_app_72ppi.jpg" class="img-fluid" alt="UnityC Logo">
            </div>
            <div class="row col-12 padding-top-20 d-none d-lg-block login-page-text">
                <div>
                    <span class="primary">C</span>onnect
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ollaborate
                    <span class="padding-left-10 padding-right-10">|</span>
                    <span class="primary">C</span>ommunity
                </div>
                <div class="padding-top-20 primary">
                    Your Secure Connection to Canadian Law Offices
                </div>
            </div>

        </div>
        <div class="col-12 col-lg-6">
            <div class="login-card">
                <form [formGroup]="formGroup">
                    <header>Register</header>

                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" autocomplete="off" my-auto-focus>
                        </mat-form-field>
                    </div>

                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" autocomplete="off">

                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="loginId" required autocomplete="off">
                            <mat-error *ngIf="formGroup.controls?.loginId?.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="formGroup.controls?.loginId?.errors?.email">Email must be a valid email
                                address
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Password</mat-label>
                            <input matInput type="password" formControlName="password" required autocomplete="off">
                            <mat-error *ngIf="formGroup.controls['password'].hasError('required')">Password is required</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasNumber')">Must have at least one number!.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasSpecial')">Must have at least one special character.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasCapitalCase')">Must have at least one uppercase letter.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('minLength')">Must be at least 8 characters in length or greater.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('allowedChar')">No spaces allowed.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('allowedChar')">Allowed characters are: A to Z, a to z, 0 to 9 and special characters.</mat-error>
                            <mat-error *ngIf="formGroup.controls['password'].hasError('hasConsecutive')">Password cannot have more than 2 consecutive same letter, number or special character.</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="legacy" >
                            <mat-label>Confirm Password</mat-label>
                            <input matInput type="password"  formControlName="retypePassword" required autocomplete="off">
                            <mat-error *ngIf="formGroup.controls['retypePassword'].hasError('required')">Confirm Password is required</mat-error>
                            <mat-error *ngIf="formGroup.controls['retypePassword'].hasError('mustMatch')">Passwords don't match.</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="login-btn padding-bottom-20 padding-top-20">
                        <button class="bold-font col-12" mat-raised-button color="accent" (click)="validateForm()">REGISTER</button>
                    </div>
                    <div *ngIf="!isInvitedUser()">
                        <re-captcha tabindex="-1"
                                    #reCaptcha
                                    siteKey="6LdDlaUZAAAAAAP87YrnzytcvlfmV4QuzaCRWNdF"
                                    size="invisible"
                                    (resolved)="captchaResolved($event)" >
                        </re-captcha>
                    </div>


                    <div class="text-center padding-top-20">
                        <div class="register">Already have an account? <a [routerLink]="['../login/']">Login</a>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
    <div  class="footer-block d-none d-lg-block justify-content-lg-center">
        <dp-footer></dp-footer>
    </div>
</div>
